import React from 'react';
import {StyleSheet, Text, View} from 'react-native';

import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';
import {DNA} from 'src/types/dnaTypes';
import AccountStore from 'src/stores/AccountStore';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import {MenuProductType} from 'src/types/Menu';
import AVFormattedCurrency from '../../elements/AVFormattedCurrency';
import {scanAndPayTemplate} from 'src/components/screens/scanAndPay/templates/scanandPayThemeHelper';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';

type SearchProductItemProps = {
  imageUrl?: string;
  name: string;
  price: number;
  item?: MenuProductType;
  dnaConfiguration?: DNA;
  onPress: () => void;
  isProductCat?: boolean;
};

function SearchProductItem(props: SearchProductItemProps) {
  const calories = props.item?.calories;

  const unitDisplayName = props?.dnaConfiguration?.showCaloriesAsKilocalories
    ? Localized.Labels.kcal
    : Localized.Labels.cal;

  return (
    <View
      accessible={true}
      accessibilityRole="button"
      accessibilityHint="Double tap to navigate to the product details screen"
      accessibilityState={{disabled: false}}
      aria-disabled={false}
      role="button"
      style={styles.container}
    >
      <Text
        accessible={true}
        accessibilityLabel={`${props.name}, `}
        accessibilityRole="text"
        aria-label={`${props.name}, `}
        maxFontSizeMultiplier={2}
        style={styles.productName}
      >
        {props.name}

        {Boolean(props.dnaConfiguration?.showCalories && calories !== null) && (
          <Text
            accessible={true}
            accessibilityLabel={`${calories} ${Localized.Labels.calories.toLowerCase()}, `}
            accessibilityRole="text"
            aria-label={`${calories} ${Localized.Labels.calories.toLowerCase()}, text, `}
            maxFontSizeMultiplier={2}
          >
            {` ${calories} ${unitDisplayName}`}
          </Text>
        )}
      </Text>
      <View style={{alignItems: 'center', flexDirection: 'row'}}>
        <AVFormattedCurrency
          style={styles.productPrice}
          value={props.price}
          accessible={true}
          aria-label={`$${props.price.toFixed(2)}, `}
          accessibilityLabel={`$${props.price.toFixed(2)}, text, `}
          currency={AccountStore.getCurrency()}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
          maxFractionDigits={2}
        />

        <RoundedAppButton
          buttonType={RoundedAppButtonType.Outline}
          buttonViewStyle={{
            overflow: 'hidden',
            borderRadius: 32,
            alignSelf: 'center',
            minWidth: 27,
            maxHeight: 38,
            borderWidth: 1.2,
            backgroundColor: Styles.Colors.PayNew.white01,
          }}
          buttonContainerStyle={{
            alignSelf: 'center',
          }}
          accessibilityLabelValue={Localized.Buttons.add}
          titleText={Localized.Buttons.add}
          textStyle={styles.addButtonText}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          aria-label={Localized.Buttons.add}
          onPress={props.onPress}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Styles.white,
    marginTop: Styles.Spacing.m2,
    marginHorizontal: Styles.Spacing.m3,
    borderRadius: scanAndPayTemplate.productListingRoundedBorder,
    paddingHorizontal: Styles.Spacing.m3,
    paddingVertical: Styles.Spacing.m2,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#E7E7E7',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.07,
    shadowRadius: 4,
    elevation: 2, // Android shadow equivalent
  },
  productPrice: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    fontFamily: scanAndPayTemplate.textFontFamily,
    color: Styles.Colors.PayNew.black01,
    marginRight: Styles.Spacing.m2,
  },
  productName: {
    flex: 1,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    fontFamily: scanAndPayTemplate.textFontFamily,
    color: Styles.Colors.PayNew.black01,
    marginRight: Styles.Spacing.m2,
  },
  addButtonText: {
    //color: Styles.white,
    fontSize: Styles.Fonts.f1 - 2,
    fontWeight: '700',
    textAlign: 'center',
  },
});

export default SearchProductItem;
